/**
 *
 */

export class UserInfoModel {
   userId:string;//用户id
    username:string;//账号
    personName:string;//姓名
    sexy:string;//性别
    idcard:string;//证件号
    birthdate:string;//生日
    unit:string;//部门名称
    deptId:string;//部门id
    email:string;//邮箱
    phone:string;//电话号码
    mobile:string;//手机号码
    wnum:string;//工号
    snum:string;//学号
    state:string;//状态
    remark:string;//备注、心情、座右铭
  lastLoginTime:string;//最后登陆时间
  userType:string;//最后登陆时间
  alApply:any;
}



// WEBPACK FOOTER //
// ./src/providers/model/users.ts